import { Alert, Anchor } from '@zillow/constellation-10';

const ListingPostedForSaleBanner = ({ forSaleUrlOnZillow }: { forSaleUrlOnZillow: string }) => {
  const learnMore = (
    <Anchor
      href="https://help.zillowrentalmanager.com/hc/en-us/articles/213339187-Advertising-For-Sale-and-For-Rent-Listings-Simultaneously"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more
    </Anchor>
  );

  const alreadyPostedForSale = forSaleUrlOnZillow ? (
    <span>
      <Anchor href={forSaleUrlOnZillow} target="_blank" rel="noopener noreferrer">
        already posted
      </Anchor>{' '}
      for sale
    </span>
  ) : (
    <span>already posted for sale elsewhere</span>
  );

  return (
    <Alert tone="info" css={{ marginBottom: '400' }}>
      This property was {alreadyPostedForSale}. You can post it for rent at the same time, but it may receive less
      visibility. {learnMore}
    </Alert>
  );
};

export default ListingPostedForSaleBanner;
